// import {ReactComponent as SelectionImg} from "./img/selection.svg";
// import {ReactComponent as SharingImg} from "./img/sharing.svg";
// import {ReactComponent as SelectionActiveImg} from "./img/selection-active.svg";
// import {ReactComponent as BtnUp} from "./img/icon-arrow_up.svg";
//
// import React, {useEffect, useRef, useState} from "react";
// import styles from "./favorites.module.css";
// import texts from "../../assets/ContextProvider/textsLocalized.json";
// import 'simplebar/dist/simplebar.min.css';
// import SimpleBar from 'simplebar-react';
// import ServerRequest from "../../serverRequests/ServerRequest";
// import {scrollToTop} from "../../assets/AdditionalFunctions/ScrollToTop";
// import {isIOS} from "../../assets/AdditionalFunctions/DefineDeviceSystem";
// import {handleFormatReleaseDate} from "../../assets/AdditionalFunctions/FormattingMovieReleaseDate";
//
//
// const Favorites = () => {
//   const [moviesCards, setMoviesCards] = useState([]);
//   const [unpickedCards, setUnpickedCards] = useState([]);
//   const timerInfoPopup = useRef(null);
//   const infoPopupRef = useRef(null);
//   const [popupIndex, setPopupIndex] = useState(null);
//   const sixthCardRef = useRef(null);
//   const [showBtnUp, setShowBtnUp] = useState(false);
//   const lastScrollY = useRef(0);
//   const isScrollingUp = useRef(false);
//   const userHash = localStorage.getItem("userHash");
//   const [movieForSearching, setMovieForSearching] = useState('');
//   const [isFocused, setIsFocused] = useState(false);
//   const [filteredMovies, setFilteredMovies] = useState([]);
//   let moviesToDisplay =
//     movieForSearching.trim() === "" ? moviesCards : filteredMovies;
//   const [shareUrl, setShareUrl] = useState(null);
//   const [iosPopupIndex, setIosPopupIndex] = useState(null);
//
//
//   const handleSearchMovie = (e) => {
//     const target = e.target.value;
//
//     setMovieForSearching(target.trimStart());
//
//     if (target.trim() === "") {
//       setFilteredMovies([]);
//       return;
//     }
//
//     const searchingWord = e.target.value.trim().toLowerCase();
//
//     const tempMoviesFilteredList = moviesCards.filter((item) => {
//       const movieLowerCase = item.name.toLowerCase();
//       const fewWordsInMovieName = movieLowerCase.split(" ");
//
//       if (searchingWord.includes(" ")) {
//         return movieLowerCase.includes(searchingWord);
//       }
//
//       return fewWordsInMovieName.some(separatedWord => separatedWord.startsWith(searchingWord));
//     }).sort((a, b) => a['name'].localeCompare(b['name']));
//
//     setFilteredMovies(tempMoviesFilteredList);
//   };
//
//
//   useEffect(() => {
//     moviesToDisplay =
//       movieForSearching.trim() === "" ? moviesCards : filteredMovies;
//   }, [movieForSearching]);
//
//
//   useEffect(() => {
//     const favoriteMovies = async () => {
//       try {
//         const serverData = await ServerRequest.getFavoriteMovies(userHash);
//
//         if (serverData.status === 404) {
//           return;
//         }
//
//         const parsedServerData = await serverData.json();
//
//         if (parsedServerData.code === 200) {
//           setMoviesCards(parsedServerData.favorites);
//         }
//       } catch (error) {
//         console.error(error);
//       }
//     };
//
//     favoriteMovies();
//   }, []);
//
//
//   useEffect(() => {
//     scrollToTop();
//   }, []);
//
//
//   const handleChooseCard = async (movieName) => {
//     const favoriteCard = moviesToDisplay.find(item => item.name === movieName);
//     const movieId = favoriteCard['name'].concat(favoriteCard['releaseDate']);
//     favoriteCard['id'] = movieId;
//
//     const isAlreadyUnpicked = unpickedCards.includes(movieName);
//
//     setUnpickedCards(prev => {
//       if (isAlreadyUnpicked) {
//         return prev.filter((name) => name !== movieName);
//       } else {
//         return [...prev, movieName];
//       }
//     });
//
//     try {
//       let response;
//       if (isAlreadyUnpicked) {
//         response = await ServerRequest.addFavoriteMovie(userHash, favoriteCard);
//       } else {
//         response = await ServerRequest.removeFavoriteMovie(userHash, movieId);
//       }
//
//       const result = await response.json();
//
//       if (!response.ok || result.code !== 200) {
//         throw new Error(result.message || 'Failed to update favorite');
//       }
//     } catch (error) {
//       console.error('Favorite error:', error);
//     }
//   }
//
//
//   const handleIosCopySharedLink = async () => {
//     if (shareUrl) {
//       if (
//         typeof navigator !== 'undefined' &&
//         navigator.clipboard &&
//         typeof navigator.clipboard.writeText === 'function'
//       ) {
//         try {
//           await navigator.clipboard.writeText(shareUrl);
//           infoPopupRef.current.classList.add(styles['movie-sharing-info-popup-ios-active']);
//
//           setTimeout(() => {
//             setIosPopupIndex(null);
//           }, 300);
//
//           console.log('Text copied to clipboard');
//         } catch (err) {
//           console.error('Failed to copy text: ', err);
//         }
//       } else {
//         console.warn('Clipboard API not supported');
//
//         const textarea = document.createElement('textarea');
//         textarea.value = shareUrl;
//         textarea.style.position = 'fixed';  // не дозволяє прокрутку до цього елемента
//         document.body.appendChild(textarea);
//         textarea.focus();
//         textarea.select();
//
//         try {
//           const successful = document.execCommand('copy');
//           console.log(successful ? 'Text copied using execCommand' : 'execCommand failed');
//         } catch (err) {
//           console.error('execCommand failed:', err);
//         }
//
//         infoPopupRef.current.classList.add(styles['movie-sharing-info-popup-ios-active']);
//
//         setTimeout(() => {
//           setIosPopupIndex(null);
//         }, 300);
//
//         document.body.removeChild(textarea);
//       }
//     }
//   };
//
//
//   const handleShowExplanation = async (index) => {
//     const selectedMovie = moviesToDisplay[index];
//
//     try {
//       let serverData = await ServerRequest.createShareLinkData(selectedMovie, userHash);
//       let parsedServerData = await serverData.json();
//
//       if (!serverData.ok) {
//         alert(parsedServerData.message || "Error sharing movie");
//         return;
//       }
//
//       const url = `${window.location.origin}/shared/${parsedServerData.token}`;
//       setShareUrl(url);
//
//       if (isIOS()) {
//         setIosPopupIndex(index);
//       } else {
//         setPopupIndex(index);
//         try {
//           await navigator.clipboard.writeText(url);
//         } catch (err) {
//           console.error("Clipboard error:", err);
//         }
//       }
//     } catch (error) {
//       console.error("Share error:", error);
//     }
//   };
//
//
//   useEffect(() => {
//     timerInfoPopup.current = setTimeout(() => {
//       setPopupIndex(null);
//     }, 2500);
//
//     return () => {
//       clearTimeout(timerInfoPopup.current);
//     }
//   }, [popupIndex]);
//
//
//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (infoPopupRef.current && !infoPopupRef.current.contains(e.target)) {
//         setIosPopupIndex(null);
//       }
//     };
//
//     document.addEventListener("pointerdown", handleClickOutside);
//     return () => {
//       document.removeEventListener("pointerdown", handleClickOutside);
//     };
//   }, []);
//
//
//   useEffect(() => {
//     const handleScroll = () => {
//       const currentScrollY = window.scrollY;
//
//       isScrollingUp.current = currentScrollY < lastScrollY.current;
//       lastScrollY.current = currentScrollY;
//     };
//
//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);
//
//
//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           setShowBtnUp(true);
//         } else if (isScrollingUp.current) {
//           setShowBtnUp(false);
//         }
//       },
//       {
//         root: null,
//         threshold: 0.5,
//       }
//     );
//
//     if (sixthCardRef.current) {
//       observer.observe(sixthCardRef.current);
//     }
//
//     return () => {
//       if (sixthCardRef.current) {
//         observer.unobserve(sixthCardRef.current);
//       }
//     };
//   }, [moviesToDisplay]);
//
//
//   const scrollToTopArrow = () => {
//     window.scrollTo(
//       {
//         top: 0,
//         behavior: 'smooth'
//       }
//     );
//     setShowBtnUp(false);
//   }
//
//
//   return (
//     <section className={styles["movies-container"]}>
//       <div className={styles['movies-title']}>
//         {texts.movies['favorite_movies_title']}
//         <div className={styles["movies-counter-container"]}>
//                   <span className={
//                     `${styles["movies-counter"]}
//                      ${(moviesCards.length - unpickedCards.length) === 50 ?
//                       `${styles["movies-counter-limit"]}` : ''}
//                   `}>
//           {moviesCards.length - unpickedCards.length}/50
//         </span>
//         </div>
//       </div>
//
//       <div className={`
//              ${styles["favorite-movie-input-container"]}
//              ${isFocused ? `${styles["favorite-movie-input-selected"]} ${styles["active"]}` : ""}`}>
//         <input className={styles["favorite-movie-input"]}
//                type="text"
//                placeholder={
//                  texts.movies["favorite-search"]}
//                value={movieForSearching}
//                onChange={handleSearchMovie}
//                onFocus={() => setIsFocused(true)}
//                onBlur={() => setIsFocused(false)}/>
//       </div>
//
//       <p className={`
//       ${styles['movie-not-found']}
//       ${movieForSearching.length >= 2 && filteredMovies.length < 1 ?
//         `${styles["visible"]}` : ''}`}>
//         {texts.movies["favorite-error-first-part"]} <br/>
//         {texts.movies["favorite-error-second-part"]}
//       </p>
//
//       {(moviesCards && moviesCards.length > 0) ? (
//         <>
//           <div className={styles['movies-cards']}>
//             {showBtnUp && (
//               <div className={styles["btn-up-global"]}>
//                 <BtnUp className={styles["btn-up"]}
//                        onClick={scrollToTopArrow}/>
//               </div>
//             )}
//             {moviesToDisplay.map((movie, index) => {
//               const isSixth = index === 5;
//               return (
//                 <div className={styles['movie-card']}
//                      key={index}
//                      ref={isSixth ? sixthCardRef : null}>
//                   <div className={styles['movie-first-block']}>
//                     <img className={styles['movie-poster']}
//                          src={movie["poster_url"] !== null ? movie["poster_url"]
//                            :
//                            require("./img/no-poster.png")}
//                          alt="image poster"/>
//                     <div className={styles['movie-first-block-description']}>
//                       <div>
//                         <div className={styles["movie-first-section"]}>
//                           <p className={styles['first-block-description-title']}>
//                             {movie.name.length < 40 ? movie.name
//                             : movie.name.substring(0, 40).concat('...')}
//                           </p>
//                           <div className={styles['first-block-interactions']}>
//                             {
//                               unpickedCards.includes(movie.name) ?
//                                 <SelectionImg className={styles['movie-selection']}
//                                               onClick={() => handleChooseCard(movie.name)}/>
//                                 :
//                                 <SelectionActiveImg className={styles['movie-selection']}
//                                                     onClick={() => handleChooseCard(movie.name)}/>
//                             }
//                             <div className={styles['movie-sharing-container']}>
//                               <SharingImg className={styles['movie-sharing']}
//                                           onClick={() => handleShowExplanation(index)}/>
//                               {popupIndex === index &&
//                                 <div ref={infoPopupRef}
//                                      className={styles["movie-sharing-info-popup"]}>
//                               <span className={styles["info-popup-description"]}>
//                                 {texts.movies["sharing-info-popup"]}
//                               </span>
//                                 </div>
//                               }
//                               {(iosPopupIndex === index) && shareUrl && (
//                                 <div ref={infoPopupRef}
//                                      onClick={handleIosCopySharedLink}
//                                      className={styles["movie-sharing-info-popup-ios"]}>
//                               <span className={styles["info-popup-description"]}>
//                                 {texts.movies["sharing-info-popup-ios"]}
//                               </span>
//                                 </div>
//                               )}
//                             </div>
//                           </div>
//                         </div>
//                         <div className={styles["movie-second-section"]}>
//                           <div className={styles['director-info-container']}>
//                             <p className={styles['director-info-title']}>
//                               {texts.movies['movies-director']}:
//                               <span className={styles['director-info-title-value']}>
//                           {movie.director ? movie.director : 'not found'}
//                         </span>
//                             </p>
//                           </div>
//                           <p className={styles['release-date']}>
//                             {handleFormatReleaseDate(movie.releaseDate)}
//                           </p>
//                         </div>
//                       </div>
//                       <div className={styles["movie-third-section"]}>
//                         {movie.genres.map((genre, index) => {
//                           return (
//                             <div className={styles['movie-genre']} key={index}>
//                               {genre}
//                             </div>)
//                         }).slice(0, 3)}
//                       </div>
//                     </div>
//                   </div>
//                   <div className={styles['movie-second-block']}>
//                     <div className={styles['movie-duration']}>
//                   <span className={styles['movie-duration-title']}>
//                     {texts.movies['movies-duration-title']}:
//                   </span>
//                       <span className={styles['movie-duration-value']}>
//                     {movie.duration ? movie.duration : 'not found'}
//                   </span>
//                     </div>
//                     <div className={styles['movie-rating']}>
//                   <span className={styles['movie-rating-title']}>
//                     {texts.movies['movies-rating-title']}:
//                   </span>
//                       <span className={styles['movie-rating-value']}>
//                   {Number(movie.ratingIMDb.toFixed(1))}
//                   </span>
//                       <img className={styles['movie-rating-star']}
//                            src={require("./img/rating.png")}
//                            alt="image rating star"/>
//                     </div>
//                   </div>
//                   <div className={styles['movie-third-block']}>
//                     <p className={styles['main-actors']}>
//                       {texts.movies['main-actors-title']}: {(movie.mainActors.length < 1) &&
//                       <span className={styles['not-found']}>not found</span>}
//                     </p>
//                     <p className={styles['movie-actor']}>
//                       {movie.mainActors ? movie.mainActors.join(", ") : null}
//                     </p>
//                   </div>
//                   <div className={styles['movie-fourth-block']}>
//                     <p className={styles['review']}>
//                       {texts.movies['review']}: {!movie.review &&
//                       <span className={styles['not-found']}>not found</span>}
//                     </p>
//                     {(movie.review && movie.review.length > 240) ?
//                       <SimpleBar className={styles['movie-review']}>
//                         {movie.review ? movie.review : 'not found'}
//                       </SimpleBar> :
//                       (movie.review && movie.review.length <= 240) ?
//                         <div
//                           className={styles['movie-review-without-scroll']}>
//                           {movie.review ? movie.review : 'not found'}
//                         </div> : null
//                     }
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         </>
//       ) : <div className={styles['no-favorites-notice']}>
//         {texts.movies["empty-favorites"]}
//       </div>
//       }
//     </section>
//   )
// }
//
// export default Favorites;

import {ReactComponent as SelectionImg} from "./img/selection.svg";
import {ReactComponent as SharingImg} from "./img/sharing.svg";
import {ReactComponent as SelectionActiveImg} from "./img/selection-active.svg";
import {ReactComponent as BtnUp} from "./img/icon-arrow_up.svg";

import React, {useEffect, useRef, useState} from "react";
import styles from "./favorites.module.css";
import texts from "../../assets/ContextProvider/textsLocalized.json";
import 'simplebar/dist/simplebar.min.css';
import SimpleBar from 'simplebar-react';
import ServerRequest from "../../serverRequests/ServerRequest";
import {scrollToTop} from "../../assets/AdditionalFunctions/ScrollToTop";
import {isIOS} from "../../assets/AdditionalFunctions/DefineDeviceSystem";
import {handleFormatReleaseDate} from "../../assets/AdditionalFunctions/FormattingMovieReleaseDate";


const Favorites = () => {
  const [moviesCards, setMoviesCards] = useState([]);
  const [unpickedCards, setUnpickedCards] = useState([]);
  const timerInfoPopup = useRef(null);
  const infoPopupRef = useRef(null);
  const [popupIndex, setPopupIndex] = useState(null);
  const sixthCardRef = useRef(null);
  const [showBtnUp, setShowBtnUp] = useState(false);
  const lastScrollY = useRef(0);
  const isScrollingUp = useRef(false);
  const userHash = localStorage.getItem("userHash");
  const [movieForSearching, setMovieForSearching] = useState('');
  const [isFocused, setIsFocused] = useState(false);
  const [filteredMovies, setFilteredMovies] = useState([]);
  let moviesToDisplay =
    movieForSearching.trim() === "" ? moviesCards : filteredMovies;
  const [shareUrl, setShareUrl] = useState(null);
  const [iosPopupIndex, setIosPopupIndex] = useState(null);


  const handleSearchMovie = (e) => {
    const target = e.target.value;

    setMovieForSearching(target.trimStart());

    if (target.trim() === "") {
      setFilteredMovies([]);
      return;
    }

    const searchingWord = e.target.value.trim().toLowerCase();

    const tempMoviesFilteredList = moviesCards.filter((item) => {
      const movieLowerCase = item.name.toLowerCase();
      const fewWordsInMovieName = movieLowerCase.split(" ");

      if (searchingWord.includes(" ")) {
        return movieLowerCase.includes(searchingWord);
      }

      return fewWordsInMovieName.some(separatedWord => separatedWord.startsWith(searchingWord));
    }).sort((a, b) => a['name'].localeCompare(b['name']));

    setFilteredMovies(tempMoviesFilteredList);
  };


  useEffect(() => {
    moviesToDisplay =
      movieForSearching.trim() === "" ? moviesCards : filteredMovies;
  }, [movieForSearching]);


  useEffect(() => {
    const favoriteMovies = async () => {
      try {
        const serverData = await ServerRequest.getFavoriteMovies(userHash);

        if (serverData.status === 404) {
          return;
        }

        const parsedServerData = await serverData.json();

        if (parsedServerData.code === 200) {
          setMoviesCards(parsedServerData.favorites);
        }
      } catch (error) {
        console.error(error);
      }
    };

    favoriteMovies();
  }, []);


  useEffect(() => {
    scrollToTop();
  }, []);


  const handleChooseCard = async (movieName) => {
    const favoriteCard = moviesToDisplay.find(item => item.name === movieName);
    const movieId = favoriteCard['name'].concat(favoriteCard['releaseDate']);
    favoriteCard['id'] = movieId;

    const isAlreadyUnpicked = unpickedCards.includes(movieName);

    setUnpickedCards(prev => {
      if (isAlreadyUnpicked) {
        return prev.filter((name) => name !== movieName);
      } else {
        return [...prev, movieName];
      }
    });

    try {
      let response;
      if (isAlreadyUnpicked) {
        response = await ServerRequest.addFavoriteMovie(userHash, favoriteCard);
      } else {
        response = await ServerRequest.removeFavoriteMovie(userHash, movieId);
      }

      const result = await response.json();

      if (!response.ok || result.code !== 200) {
        throw new Error(result.message || 'Failed to update favorite');
      }
    } catch (error) {
      console.error('Favorite error:', error);
    }
  }


  const handleIosCopySharedLink = async () => {
    if (shareUrl) {
      if (
        typeof navigator !== 'undefined' &&
        navigator.clipboard &&
        typeof navigator.clipboard.writeText === 'function'
      ) {
        try {
          await navigator.clipboard.writeText(shareUrl);
          infoPopupRef.current.classList.add(styles['movie-sharing-info-popup-ios-active']);

          setTimeout(() => {
            setIosPopupIndex(null);
          }, 300);

          console.log('Text copied to clipboard');
        } catch (err) {
          console.error('Failed to copy text: ', err);
        }
      } else {
        console.warn('Clipboard API not supported');

        const textarea = document.createElement('textarea');
        textarea.value = shareUrl;
        textarea.style.position = 'fixed';  // не дозволяє прокрутку до цього елемента
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();

        try {
          const successful = document.execCommand('copy');
          console.log(successful ? 'Text copied using execCommand' : 'execCommand failed');
        } catch (err) {
          console.error('execCommand failed:', err);
        }

        infoPopupRef.current.classList.add(styles['movie-sharing-info-popup-ios-active']);

        setTimeout(() => {
          setIosPopupIndex(null);
        }, 300);

        document.body.removeChild(textarea);
      }
    }
  };


  const handleShowExplanation = async (index) => {
    const selectedMovie = moviesToDisplay[index];

    try {
      let serverData = await ServerRequest.createShareLinkData(selectedMovie, userHash);
      let parsedServerData = await serverData.json();

      if (!serverData.ok) {
        alert(parsedServerData.message || "Error sharing movie");
        return;
      }

      const url = `${window.location.origin}/shared/${parsedServerData.token}`;
      setShareUrl(url);

      if (isIOS()) {
        setIosPopupIndex(index);
      } else {
        setPopupIndex(index);
        try {
          await navigator.clipboard.writeText(url);
        } catch (err) {
          console.error("Clipboard error:", err);
        }
      }
    } catch (error) {
      console.error("Share error:", error);
    }
  };


  useEffect(() => {
    timerInfoPopup.current = setTimeout(() => {
      setPopupIndex(null);
    }, 2500);

    return () => {
      clearTimeout(timerInfoPopup.current);
    }
  }, [popupIndex]);


  useEffect(() => {
    const handleClickOutside = (e) => {
      if (infoPopupRef.current && !infoPopupRef.current.contains(e.target)) {
        setIosPopupIndex(null);
      }
    };

    document.addEventListener("pointerdown", handleClickOutside);
    return () => {
      document.removeEventListener("pointerdown", handleClickOutside);
    };
  }, []);


  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      isScrollingUp.current = currentScrollY < lastScrollY.current;
      lastScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShowBtnUp(true);
        } else if (isScrollingUp.current) {
          setShowBtnUp(false);
        }
      },
      {
        root: null,
        threshold: 0.5,
      }
    );

    if (sixthCardRef.current) {
      observer.observe(sixthCardRef.current);
    }

    return () => {
      if (sixthCardRef.current) {
        observer.unobserve(sixthCardRef.current);
      }
    };
  }, [moviesToDisplay]);


  const scrollToTopArrow = () => {
    window.scrollTo(
      {
        top: 0,
        behavior: 'smooth'
      }
    );
    setShowBtnUp(false);
  }


  return (
    <section className={styles["movies-container"]}>
      <div className={styles['movies-title']}>
        {texts.movies['favorite_movies_title']}
        <div className={styles["movies-counter-container"]}>
                  <span className={
                    `${styles["movies-counter"]}
                     ${(moviesCards.length - unpickedCards.length) === 50 ?
                      `${styles["movies-counter-limit"]}` : ''}
                  `}>
          {moviesCards.length - unpickedCards.length}/50
        </span>
        </div>
      </div>

      <div className={`
             ${styles["favorite-movie-input-container"]}
             ${isFocused ? `${styles["favorite-movie-input-selected"]} ${styles["active"]}` : ""}`}>
        <input className={styles["favorite-movie-input"]}
               type="text"
               placeholder={
                 texts.movies["favorite-search"]}
               value={movieForSearching}
               onChange={handleSearchMovie}
               onFocus={() => setIsFocused(true)}
               onBlur={() => setIsFocused(false)}/>
      </div>

      <p className={`
      ${styles['movie-not-found']}
      ${movieForSearching.length >= 2 && filteredMovies.length < 1 ?
        `${styles["visible"]}` : ''}`}>
        {texts.movies["favorite-error-first-part"]} <br/>
        {texts.movies["favorite-error-second-part"]}
      </p>

      {(moviesCards && moviesCards.length > 0) ? (
        <>
          <div className={styles['movies-cards']}>
            {showBtnUp && (
              <div className={styles["btn-up-global"]}>
                <BtnUp className={styles["btn-up"]}
                       onClick={scrollToTopArrow}/>
              </div>
            )}
            {moviesToDisplay.map((movie, index) => {
              const isSixth = index === 5;
              return (
                <div className={styles['movie-card']}
                     key={index}
                     ref={isSixth ? sixthCardRef : null}>
                  <div className={styles['movie-first-block']}>
                    <img className={styles['movie-poster']}
                         src={movie["poster_url"] !== null ? movie["poster_url"]
                           :
                           require("./img/no-poster.png")}
                         alt="image poster"/>
                    <div className={styles['movie-first-block-description']}>
                      <div>
                        <div className={styles["movie-first-section"]}>
                          <p className={styles['first-block-description-title']}>
                            {movie.name.length < 40 ? movie.name
                              : movie.name.substring(0, 40).concat('...')}
                          </p>
                          <div className={styles['first-block-interactions']}>
                            {
                              unpickedCards.includes(movie.name) ?
                                <SelectionImg className={styles['movie-selection']}
                                              onClick={() => handleChooseCard(movie.name)}/>
                                :
                                <SelectionActiveImg className={styles['movie-selection']}
                                                    onClick={() => handleChooseCard(movie.name)}/>
                            }
                            <div className={styles['movie-sharing-container']}>
                              <SharingImg className={styles['movie-sharing']}
                                          onClick={() => handleShowExplanation(index)}/>
                              {popupIndex === index &&
                                <div ref={infoPopupRef}
                                     className={styles["movie-sharing-info-popup"]}>
                              <span className={styles["info-popup-description"]}>
                                {texts.movies["sharing-info-popup"]}
                              </span>
                                </div>
                              }
                              {(iosPopupIndex === index) && shareUrl && (
                                <div ref={infoPopupRef}
                                     onClick={handleIosCopySharedLink}
                                     className={styles["movie-sharing-info-popup-ios"]}>
                              <span className={styles["info-popup-description"]}>
                                {texts.movies["sharing-info-popup-ios"]}
                              </span>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={styles["movie-third-section"]}>
                        {movie.genres.map((genre, index) => {
                          return (
                            <div className={styles['movie-genre']} key={index}>
                              {genre}
                            </div>)
                        }).slice(0, 3)}
                      </div>
                    </div>
                  </div>
                  <div className={styles['movie-second-block']}>
                    <div className={styles["movie-second-block--first"]}>
                      <div className={styles["movie-second-section"]}>
                        <div className={styles['director-info-container']}>
                          <p className={styles['director-info-title']}>
                            {texts.movies['movies-director']}:
                            <span className={styles['director-info-title-value']}>
                        {movie.director ? movie.director : 'not found'}
                      </span>
                          </p>
                        </div>
                        <div className={styles['release-date-info-container']}>
                          <p className={styles['release-date-title']}>
                            {texts.movies['movies-release-date']}:
                            <span className={styles['release-date']}>
                              {handleFormatReleaseDate(movie.releaseDate)}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className={styles["movie-second-block--second"]}>
                      <div className={styles['movie-duration']}>
                  <span className={styles['movie-duration-title']}>
                    {texts.movies['movies-duration-title']}:
                  </span>
                        <span className={styles['movie-duration-value']}>
                    {movie.duration ? movie.duration : 'not found'}
                  </span>
                      </div>
                      <div className={styles['movie-rating']}>
                  <span className={styles['movie-rating-title']}>
                    {texts.movies['movies-rating-title']}:
                  </span>
                        <span className={styles['movie-rating-value']}>
                  {Number(movie.ratingIMDb.toFixed(1))}
                  </span>
                        <img className={styles['movie-rating-star']}
                             src={require("./img/rating.png")}
                             alt="image rating star"/>
                      </div>
                    </div>
                  </div>
                  <div className={styles['movie-third-block']}>
                    <p className={styles['main-actors']}>
                      {texts.movies['main-actors-title']}: {(movie.mainActors.length < 1) &&
                      <span className={styles['not-found']}>not found</span>}
                    </p>
                    <p className={styles['movie-actor']}>
                      {movie.mainActors ? movie.mainActors.join(", ") : null}
                    </p>
                  </div>
                  <div className={styles['movie-fourth-block']}>
                    <p className={styles['review']}>
                      {texts.movies['review']}: {!movie.review &&
                      <span className={styles['not-found']}>not found</span>}
                    </p>
                    {(movie.review && movie.review.length > 240) ?
                      <SimpleBar className={styles['movie-review']}>
                        {movie.review ? movie.review : 'not found'}
                      </SimpleBar> :
                      (movie.review && movie.review.length <= 240) ?
                        <div
                          className={styles['movie-review-without-scroll']}>
                          {movie.review ? movie.review : 'not found'}
                        </div> : null
                    }
                  </div>
                </div>
              );
            })}
          </div>
        </>
      ) : <div className={styles['no-favorites-notice']}>
        {texts.movies["empty-favorites"]}
      </div>
      }
    </section>
  )
}

export default Favorites;